import "./style.less";

export default function HeaderDesktop() {
    return {
        restrict: "E",
        scope: {
            house: "=", //object
        },
        template: require("./template.html"),

        controller: function (
            $scope,
            $location,
            Basket,
            Auth,
            navService,
            ENV,
            Users
        ) {
            // used in header // is this the navigation items??
            // siteService.getMenuNodes().then(function (nodes) {

            //     $scope.nodes = nodes;
            // });

            $scope.env = ENV.type;

            Users.getAuthenticatedUser().then(
                (res) => {
                    $scope.user = res;
                },
                (err) => {
                    $scope.user = null;
                }
            );

            $scope.mainNavItems = navService.mainNavItems;

            // overviewFilter
            // which return example.. all activities (date independant)
            // searchType : 1 = activities , 2 = places/location
            // categoryID : find all (searchType) with a specific category
            $scope.listAll = function ($event, item) {
                if ($event.metaKey) {
                    // if user holds cmd/ctrl when click
                    window.open(item.path, "_blank");
                } else {
                    $location.path(item.path);
                }
            };

            // AUTHENTICATION Identity Server
            $scope.login = function ($event) {
                Auth.login();
                $event.preventDefault();
            };

            // AUTHENTICATION Identity Server
            $scope.logout = function ($event) {
                Basket.resetBasket();
                Auth.logout();
                $event.preventDefault();
            };
        },
    };
}
